module.exports = __webpack_public_path__ + "static/desk-sean-wes-836de3fb21482adcd73f65b312c71bc9.jpg";